import React from "react";

// launchbox_metadata.disable_3d — null keeps the 3D box on; the other two turn it off
// (served to the app as metadata.disable_3d: true + disable_3d_reason).
export const COVER_3D_OPTIONS = [
  { key: null, label: "3D on" },
  { key: "not_cover", label: "Off · not a cover", title: "LaunchBox's front isn't a box cover (a photo, a poster, a cartridge)" },
  { key: "manual", label: "Off · other reason", title: "The cover is a box but renders badly in 3D" },
];

export function cover3dLabel(key) {
  return (COVER_3D_OPTIONS.find((option) => option.key === key) || COVER_3D_OPTIONS[0]).label;
}

function Cover3dPicker({ value, onChange, disabled }) {
  return (
    <div className="admin-tgdb-link-form admin-metadata-presets" role="radiogroup" aria-label="3D box">
      {COVER_3D_OPTIONS.map((option) => (
        <button
          type="button"
          key={option.label}
          role="radio"
          aria-checked={value === option.key}
          className={`admin-metadata-preset ${value === option.key ? "admin-metadata-preset--active" : ""}`}
          onClick={() => onChange(option.key)}
          title={option.title}
          disabled={disabled}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}

export default Cover3dPicker;
